// Using full path import due to this function being used in the cypress tests
import { sum } from "lodash";

import { HZ_VALUES } from "constants/audiogram";
import { isBlank } from "utils/common";

const getACValue = (
  airConductionValues: (string | number | null)[],
  hz: number
) => {
  const index = HZ_VALUES.findIndex((i) => i === hz);
  return airConductionValues?.at(index) ?? null;
};

const getHzAverage = (values: (string | number | null)[]) => {
  const result = values
    .filter((value) => !isBlank(value) && !isNaN(Number(value)))
    .map((value) => Number(value));

  if (!result.length) return null;

  const value = sum(result) / result.length;
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export function getPureToneAverage(
  airConductionValues: (string | number | null)[]
): number | null {
  return getHzAverage([
    getACValue(airConductionValues, 500),
    getACValue(airConductionValues, 1000),
    getACValue(airConductionValues, 2000)
  ]);
}

export function getHighFrequencyPureToneAverage(
  airConductionValues: (string | number | null)[]
): number | null {
  return getHzAverage([
    getACValue(airConductionValues, 3000),
    getACValue(airConductionValues, 4000),
    getACValue(airConductionValues, 6000)
  ]);
}
